import { FC, useEffect, useState } from 'react';
import ModalDeleteConsumer from './index';
import { I_GetConsumerCountOpenTickets, ModalDeleteConsumerControllerInterface } from './indexModel';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import emitter from '../../../../../core/shared/emitter';
import UserService from '../../../../../services/user-service';
import { setShowAlertFeedback } from '../../../../../store/internal';
import { AppRequesterController } from '../../../../../services/appRequester/appRequesterController';

const AppRequesterConst = new AppRequesterController();

const ModalDeleteConsumerController: FC<ModalDeleteConsumerControllerInterface> = (props) => {
  const { t } = useTranslation('ModalDeleteConsumer');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState<{ userId: string, consumerName?: string }[]>(null);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [mode, setMode] = useState<'single' | 'multiple'>('single');
  const [hasConsumerTickets, setHasConsumerTickets] = useState<boolean>(false);
  const [consumerTickets, setConsumerTickets] = useState<number>(0);

  useEffect(() => {
    emitter.on('open-modal-delete-consumer', data => {
      setData(data);
      verifyTicketsConsumer(data || []);
      if (data.length > 1) {
        setMode('multiple');
      } else {
        setMode('single');
      }
    });

    return () => {
      emitter.off('open-modal-delete-consumer');
    }
  }, []);

  const handleSubmit = () => {
    deleteConsumer();
  }

  const verifyTicketsConsumer = (ids: { userId: string, consumerName?: string }[]) => {
    if (ids && ids.length > 0) {
      const headers = UserService.getHeaders();
      const params = { ids: ids.map(item => item.userId).toString() };
      setLoadingDelete(true);

      const config = {
        headers,
        params
      }

      AppRequesterConst.Get(
        '/consumer/count-open-tickets', config,
        () => {},
        (response: I_GetConsumerCountOpenTickets) => {
          if (response.status === 200) {
            let quantity = 0;
            
            response.data.data.forEach(item => {
              quantity += Number(item.quantity);
            });
            setConsumerTickets(quantity);
            setHasConsumerTickets(true);
          } else {
            setConsumerTickets(0);
            setHasConsumerTickets(false);
          }
        },
        (error: any) => {
          dispatch(setShowAlertFeedback({ message: t('alert.unexpected_error'), visibility: true, signalIcon: false }));
          setConsumerTickets(0);
          setHasConsumerTickets(false);
        },
        navigate, dispatch, setLoadingDelete, {}
      );
    }
  }

  const deleteConsumer = () => {
    if (data && data.length > 0) {
      const headers  = UserService.getHeaders();

      const ids = data.map(item => item.userId);

      const config = {
        headers,
        data: { ids }
      }

      AppRequesterConst.Delete(
        `/consumer`, config,
        () => {},
        () => {
          if (data.length === 1) {
            dispatch(setShowAlertFeedback({ message: t('alert.deleted_successfully_single', { consumerName: data[0].consumerName }), visibility: true, signalIcon: true }));
          } else {
            dispatch(setShowAlertFeedback({ message: t('alert.deleted_successfully_multi', { deletedCount: data.length }), visibility: true, signalIcon: true }));
          }
          props.hide(true, ids);
        },
        (error: any) => {
          dispatch(setShowAlertFeedback({ message: t('alert.unexpected_error'), visibility: true, signalIcon: false }));
        },
        navigate, dispatch, setLoadingDelete
      );
    }
  }

  return (
    <ModalDeleteConsumer 
      t={t}
      mode={mode}
      show={props.show}
      hide={props.hide}
      data={data}
      loadingDelete={loadingDelete}
      handleSubmit={handleSubmit}
      hasConsumerTickets={hasConsumerTickets}
      consumerTickets={consumerTickets}
    />
  );
};

export default ModalDeleteConsumerController;
